import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export default class FaIcon extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['lg', '2x', '3x', '4x']),
    rotate: PropTypes.oneOf(['90', '180', '270', '360']),
    flip: PropTypes.oneOf(['horizontal', 'vertical']),
    spin: PropTypes.bool,
    fixedWidth: PropTypes.bool,
    pulse: PropTypes.bool,
    className: PropTypes.string
  }

  render () {
    const {
      name, size, rotate, flip, spin, fixedWidth, pulse,
      className, ...props
    } = this.props

    const classes = classNames(
      className, 'fa', `fa-${name}`,
      {
        'fa-fw': fixedWidth,
        'fa-spin': spin,
        'fa-pulse': pulse,
        [`fa-rotate-${rotate}`]: !!rotate,
        [`fa-${size}`]: !!size,
        [`fa-flip-${flip}`]: !!flip
      }
    )

    return <i className={classes} {...props} />
  }
}
